<template><div><h1>VUX V2.4.1 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] readonly 值变化时重新渲染 #1593</li>
<li>[feature] 支持通过 prop:default-selected-value 设置默认选中日期 #1576</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[fix] 修复json格式不正确引起的bug #1584</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] popup-picker头部区域屏蔽滑动事件 #1596</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.4.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.4.1-240.vue?05b23ef6